import palette from '../../palette';

export default {
  colorPrimary: {
    color: palette.blueMain
  }
};
